export function formatTargetDurationSeconds(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const hours = Math.floor(s / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const parts: string[] = [];

  if (hours > 0) {
    parts.push(`${hours}h`);
  }

  if (minutes > 0 || parts.length === 0) {
    parts.push(`${minutes}m`);
  }
  
  return parts.join(' ');
}

const UNSIGNED_INT_STRING = /^[0-9]+$/;

function parseDurationComponent(raw: string): number | null {
  const s = raw.trim();

  if (s === '') {
    return 0;
  }

  if (!UNSIGNED_INT_STRING.test(s)) {
    return null;
  }

  const n = Number(s);

  if (!Number.isFinite(n) || n < 0) {
    return null;
  }

  return n;
}

export function parseDurationToSeconds(
  hoursRaw: string,
  minutesRaw: string
): number | null {
  const hours = parseDurationComponent(hoursRaw);
  const minutes = parseDurationComponent(minutesRaw);

  if (hours === null || minutes === null) {
    return null;
  }

  if (minutes > 59) {
    return null;
  }

  return hours * 3600 + minutes * 60;
}
